import {AccessForm} from "@shop/frontend/web/js/classes/form/AccessForm";
import {DefaultForm} from "@frontend/src/js/classes/DefaultForm";

export function formValidation() {
    prohibitInputNumbers();
    const $forms = document.querySelectorAll(".js-validate-form");

    if (!$forms.length) {
        return false;
    }

    $forms.forEach($form => {
        if ($form.id === "organization-access-form") {
            const accessForm = new AccessForm($form);
            accessForm.init();
        } else {
            const defaultForm = new DefaultForm($form);
            defaultForm.init();
        }
    });
}

const prohibitInputNumbers = () => {
    const inputIds = [
        "registrationform-first",
        "registrationform-second",
        "fastregistrationform-first",
        "fastregistrationform-second",
        "settings-form-first",
        "settings-form-second",
        "settings-form-middle",
        "verificationform-second",
        "verificationform-first",
        "verificationform-middle",
    ];
    const normalizedInputIds = inputIds.map(id => `#${id}`);
    const inputElements = document.querySelectorAll(normalizedInputIds.join());
    const regex = /^[a-zа-яё]+$/iu;

    inputElements.forEach(input => {
        input.addEventListener("input", e => {
            const chars = Array.from(e.target.value);
            const filteredChars = chars.filter(char => regex.test(char)).join("");
            e.target.value = filteredChars;
        });
    });
};